import { render } from "./ButtonCopyToClipboard.vue?vue&type=template&id=b6af05c0"
import script from "./ButtonCopyToClipboard.vue?vue&type=script&lang=js"
export * from "./ButtonCopyToClipboard.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/laravel/sundae-scoops/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__